import { IconProps } from '.';

const TenIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <g clipPath="url(#clip0_18177_142896)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 37.5C29.665 37.5 37.5 29.665 37.5 20C37.5 10.335 29.665 2.5 20 2.5C10.335 2.5 2.5 10.335 2.5 20C2.5 29.665 10.335 37.5 20 37.5ZM20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />

        <g transform="translate(8,10)">
          <path
            d="M17.0682 18.6334C15.7182 18.6334 14.5182 18.2501 13.4682 17.4834C12.4182 16.7001 11.5932 15.6334 10.9932 14.2834C10.4098 12.9168 10.1182 11.3501 10.1182 9.58345C10.1182 7.81678 10.4098 6.25845 10.9932 4.90845C11.5932 3.54178 12.4098 2.47511 13.4432 1.70845C14.4932 0.925114 15.7015 0.533447 17.0682 0.533447C18.4348 0.533447 19.6348 0.925114 20.6682 1.70845C21.7182 2.47511 22.5432 3.54178 23.1432 4.90845C23.7432 6.25845 24.0432 7.81678 24.0432 9.58345C24.0432 11.3501 23.7432 12.9168 23.1432 14.2834C22.5598 15.6334 21.7432 16.7001 20.6932 17.4834C19.6432 18.2501 18.4348 18.6334 17.0682 18.6334ZM17.0682 16.3834C17.9515 16.3834 18.7348 16.0918 19.4182 15.5084C20.1182 14.9251 20.6598 14.1251 21.0432 13.1084C21.4265 12.0918 21.6182 10.9168 21.6182 9.58345C21.6182 8.25011 21.4265 7.07511 21.0432 6.05845C20.6598 5.02511 20.1182 4.21678 19.4182 3.63345C18.7348 3.05011 17.9515 2.75845 17.0682 2.75845C16.1848 2.75845 15.4015 3.05011 14.7182 3.63345C14.0348 4.21678 13.5015 5.02511 13.1182 6.05845C12.7348 7.07511 12.5432 8.25011 12.5432 9.58345C12.5432 10.9168 12.7348 12.1001 13.1182 13.1334C13.5015 14.1501 14.0348 14.9501 14.7182 15.5334C15.4015 16.1001 16.1848 16.3834 17.0682 16.3834Z"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
          <path
            d="M4.16797 18.3334V2.15835L4.39297 0.833349H6.56797V18.3334H4.16797ZM0.292969 5.60835V3.38335C0.659635 3.40002 1.08464 3.28335 1.56797 3.03335C2.06797 2.78335 2.56797 2.45835 3.06797 2.05835C3.56797 1.65835 4.00964 1.24168 4.39297 0.80835L5.91797 2.45835C5.3513 3.05835 4.75964 3.60002 4.14297 4.08335C3.5263 4.56668 2.89297 4.95002 2.24297 5.23335C1.60964 5.51668 0.959635 5.64168 0.292969 5.60835Z"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18177_142896">
          <rect
            width="40"
            height="40"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TenIcon;
